export default {
	title: {
		initial: 'BasisBijbel'
	},
	paypal: 'https://www.paypal.com/donate/?hosted_button_id=ZETQ9SDSZN3PL&locale.x=nl',
	labels: {
		sign_in: {
			success: {
				prefix: 'Welkom ',
				suffix: '! Je bent nu ingelogd.'
			},
			error: 'Je hebt een onbekend e-mailadres of wachtwoord ingevoerd.'
		},
		sign_up: {
			error: 'Het is op dit moment helaas niet mogelijk om te registreren. Probeer het later nogmaals.'
		},
		sign_out: {
			success: 'Je bent nu uitgelogd!'
		},
		forgot: {
			error: 'Er kan momenteel helaas geen e-mail bericht verstuurd worden.'
		},
		delete_user: {
			success: 'Jouw account is succesvol verwijderd.',
			error: 'We kunnen jouw account momenteel helaas niet verwijderen.'
		}
	}
};